/**
 * WorkflowType — DRIP campaigns deliver messages sequentially over time.
 * PILL campaigns are event-triggered and execute immediately.
 */
export enum WorkflowType {
  DRIP = 'drip',
  PILL = 'pill',
}